import { DateTime } from 'luxon';
import { CouponPackMaster } from '../../../../graphql/generated';
import { CouponPackMasterFormInput, CouponPackMasterImageBodyProps } from '../../../../types/couponPackMaster';
import { SelectedFile } from '../../../../types/file';

export function logoImageProps(input: {
  currentImageUrl?: string;
  selectedFile: SelectedFile;
  validateAndSetFile: (f: File) => void;
  setDeleteFile: () => void;
}): CouponPackMasterImageBodyProps {
  return {
    currentImageUrl: input.currentImageUrl,
    fileTypeText: 'ロゴ画像',
    widthText: '横幅600px以上',
    selectedFile: input.selectedFile,
    validateAndSetFile: input.validateAndSetFile,
    setDeleteFile: input.setDeleteFile,
    deletable: true,
    maxSizeBytesText: '1MB',
  };
}

export function couponImageProps(input: {
  currentImageUrl?: string;
  selectedFile: SelectedFile;
  validateAndSetFile: (f: File) => void;
  setDeleteFile: () => void;
}): CouponPackMasterImageBodyProps {
  return {
    currentImageUrl: input.currentImageUrl,
    fileTypeText: 'ロゴ画像',
    widthText: '横幅600px以上',
    selectedFile: input.selectedFile,
    validateAndSetFile: input.validateAndSetFile,
    setDeleteFile: input.setDeleteFile,
    deletable: true,
    maxSizeBytesText: '1MB',
  };
}

export function reproduceInputFromCouponPackMaster(m: CouponPackMaster): CouponPackMasterFormInput {
  return {
    unAvailable: !m.available,
    couponName: m.couponName,
    displayCouponName: m.displayCouponName,
    couponCode: m.couponCode,
    displayStartDate: m.displayStartDate ? DateTime.fromISO(m.displayStartDate) : null,
    displayEndDate: m.displayEndDate ? DateTime.fromISO(m.displayEndDate) : null,
    validityStartDate: m.validityStartDateTime ? DateTime.fromISO(m.validityStartDateTime) : null,
    validityStartTime: m.validityStartDateTime ? DateTime.fromISO(m.validityStartDateTime) : null,
    validityEndDate: m.validityEndDateTime ? DateTime.fromISO(m.validityEndDateTime) : null,
    validityEndTime: m.validityEndDateTime ? DateTime.fromISO(m.validityEndDateTime) : null,
    description: m.description || '',
    note: m.note || '',
    products: m.products.map((item) => ({
      id: item.couponMasterId,
      couponMasterName: item.couponMasterName,
      quantity: item.quantity.toString(),
      maxCouponsPerOrder: item.maxCouponsPerOrder?.toString() || '',
      couponMasterCode: item.couponMasterCode?.toString() || '',
      imageUrl: item.imageUrl || '',
      validityEndDateTime: item.validityEndDateTime || '',
      displayEndDate: item.displayEndDate || '',
      displayStartDate: item.displayStartDate || '',
      displayValidityDate: item.displayValidityDate || false,
      telNumber: item.telNumber || '',
      information: item.information || '',
      couponAmount: item.couponAmount || 0,
      smartCheckImageUrl: item.smartCheckImageUrl || undefined,
      smartCheckSetting: item.smartCheckSetting || undefined,
      imageServer: item.barcode?.imageServer || undefined,
      couponNameHtml: item.couponNameHtml || undefined,
    })),
    status: m.status || '',
    imageUrl: '',
  };
}
